module.exports = __webpack_public_path__ + "static/media/6.c2268030.svg";